  // src/components/RankingTable.jsx
  import React, { useState, useEffect } from "react";
  import axios from "axios";
  import { toast } from "react-toastify";
  // import TeamImageModal from "../TeamImageModal/TeamImageModal";
  import { useAuth } from "../../Context/AuthContext";
  import "./RankingTable.css"

  const API = process.env.REACT_APP_API;

  function RankingTable({ league, stage }) {
    const { user, token } = useAuth(); 
      
    const [rankingTable, setRankingTable] = useState([]);
    const [teams, setTeams] = useState([]);
    // const [selectedTeam, setSelectedTeam] = useState(null);
    // const [modalOpen, setModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    // טעינת כל הבתים של שלב מסוים
    const fetchRankingTable = async () => {
      if (!league || !stage ) return;
      setLoading(true);
      try {
        const res = await axios.get(`${API}/api/rankings/${league._id}?stage=${stage._id}`);
        setRankingTable(res.data || []);
        fetchTeams();
      } catch (err) {
          console.error("שגיאה בטעינת טבלת דירוג:", err);
          setRankingTable({});
      } finally {
          setLoading(false);
      }
    };

    // טעינת רשימת קבוצות
    const fetchTeams = async () => {
      if (!league) return;
      try {
        const res = await axios.get(`${API}/api/teams/${league._id}`);
        setTeams(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
          console.error("שגיאה בטעינת קבוצות:", err);
      }
    }; 

    useEffect(() => {
      if (league && stage) {
        fetchRankingTable();
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [league, stage]);

    const handleAddDivision = async () => {
      const divisionName = window.prompt("הזן שם לבית החדש:");
      if (!divisionName) return;

      try {
        await axios.post(`${API}/api/rankings/${league._id}/stage/${stage._id}/division`, { name: divisionName },
          {
            headers: {
              Authorization: `Bearer ${token}` // צריך להיות token תקין
            }
          }
        );
        fetchRankingTable(); // רענון הטבלאות אחרי יצירה
        toast.success(`בית ${divisionName} נוסף בהצלחה`);
          
      } catch (err) {
          console.error("שגיאה ביצירת בית חדש:", err);
          toast.success(`שגיאה ביצירת בית ${divisionName}`);
      }
    };

    const handleEditDivision = async (oldDivision) => {
      const newDivision = window.prompt("הזן שם חדש לבית:", oldDivision);
      if (!newDivision) return;
      try {
        await axios.patch(`${API}/api/rankings/${league.code}/stage/${stage._id}/division/${oldDivision}`, { newDivision },
          {
            headers: {
              Authorization: `Bearer ${token}` // צריך להיות token תקין
            }
          });
        fetchRankingTable();
        toast.success(`שם הבית שונה בהצלחה ל-"${newDivision}"`);

      } catch (err) {
          console.error("שגיאה בעריכת הבית:", err);
      }
    };

    const handleDeleteDivision = async (division) => {
      if (!window.confirm(`למחוק את הבית "${division}"?`)) return;

      try {
        await axios.delete(`${API}/api/rankings/${league.code}/stage/${stage._id}/division/${division}`,
          {
            headers: {
              Authorization: `Bearer ${token}` // צריך להיות token תקין
            }
          }
        );
        fetchRankingTable();
      } catch (err) {
          console.error("שגיאה במחיקת הבית:", err);
      }
    };

    // const findTeamData = (teamName) => {
    //   if (!teamName || !Array.isArray(teams)) return null;

    //   const normalize = (str) => 
    //   str
    //     .trim()
    //     .toLowerCase()
    //     .replace(/[\s\-_]+/g, ""); // הסרת רווחים ומקפים

    //   const normalizedName = normalize(teamName)
    //   return teams.find(t => t.team && normalize(t.team) === normalizedName) || null;
    // };

    return (
      <div className="ranking-table-container">
          {user?.isAdmin && (
          <div className="add-division">
              <button onClick={handleAddDivision} className="add-division-button">➕ הוסף בית חדש</button>
          </div>
          )}

        {loading && (
          <div className="loading-spinner-container">
            <div className="spinner"></div>
          </div>
        )}
      
        {!loading && rankingTable.length === 0 && (
          <p className="no-division-message">
            אין נתוני דירוג להצגה לשלב "{stage?.name}"
          </p>
        )}


        {/* טבלת דירוג */}
        {rankingTable && rankingTable.map((division) => (
          <div key={division._id} className="division-wrapper">
              <div className="division-header">
              <h2>{division.name}</h2>
              {user?.isAdmin && (
                  <div className="actions">
                  <button onClick={() => handleEditDivision(division.name)}>✏️ ערוך שם בית</button>
                  <button onClick={() => handleDeleteDivision(division.name)}>🗑️ מחק בית</button>
                  </div>
              )}
              </div>

              <table className="ranking-table">
              <thead>
                  <tr>
                  <th colSpan="9" className="last-updated">
                      עדכון אחרון: {new Date(division.lastUpdated).toLocaleDateString("he-IL")}
                  </th>
                  </tr>
                  <tr>
                  <th>דירוג</th>
                  <th>קבוצה</th>
                  <th>משחקים</th>
                  <th>נצח.</th>
                  <th>הפס.</th>
                  <th>ניקוד</th>
                  <th>נק' זכות</th>
                  <th>נק' חובה</th>
                  <th>יחס נק'</th>
                  </tr>
              </thead>
              <tbody>
                  {division.table.map((row, idx) => {
  
                  return (
                      <tr key={idx}>
                      <td>{row.rankingNumber || ""}</td>
                      <td className="team-column">
                        {row.team}
                      </td>
                      <td>{row.gamesPlayed ?? ""}</td>
                      <td className="wins-column">{row.wins ?? ""}</td>
                      <td className="losses-column">{row.losses ?? ""}</td>
                      <td>{row.points ?? ""}</td>
                      <td>{row.pointsWon ?? ""}</td>
                      <td>{row.pointsLost ?? ""}</td>
                      <td>{row.ratio ?? ""}</td>
                      </tr>
                  );
                  })}
              </tbody>
              </table>
          </div>
          ))}

        {/* <TeamImageModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          teamName={selectedTeam?.team}
          imageUrl={selectedTeam?.image?.trim() || null}
        /> */}
      </div>
    );
  }

  export default RankingTable;
